<style lang="scss">
	#on-center1 {
		.ant-form-item-label {
			margin-top: 0rem;
		}
	}

	#handitemedits {
		.ant-form-item{
			margin-bottom: 0;
		}
		.ant-row,
		.ant-calendar-picker {
			width: 100%;
		}

		.ant-form-item-label {
			// width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 100% !important;

			.wart-t {
				width: 100%;
			}
		}

		.ant-calendar-picker-input {
			width: 100%;
		}

		.myright {
			.ant-form-item-label {
				// width: 30% !important;
				// padding-left: 3.5%;
			}
		}
		.on-center11 {
			.ant-form-item-label {
				// width: 15% !important;
				// padding-left: 1.5%;
			}
			.ant-form-item-control-wrapper {
				width: 100% !important;
			
				.wart-t {
					width: 100%;
				}
			}
		}

		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 100% !important;
			}

			.ant-form-item-control-wrapper {
				width: 60% !important;

			}
		}

		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
	.ant-form-explain{
		display: none;
	}
</style>

<template>
	<div id='handitemedits'>
		<div class="tabelMoreFzView main-mybody">
			<div class="tabelMoreFzViewIn">
				<a-form-model ref='ruleForm' :model="form"  layout="vertical" :rules='rules' hideRequiredMark>
					<a-row type='flex' justify='space-between'>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Company Name" prop='company_name'>
								<a-input v-model="form.company_name" class='wart-t' 
								@input="form.company_name=form.company_name.replace(/[^a-z A-Z]/g,'')" 
								:disabled='ipoAduitAdmin'/>
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Business Nature" prop='business_natur'>
								<!-- <Situationall v-model="form.business_natur" :url='$api.getParamList'
									:disabled='ipoAduitAdmin'
									:valonce='JSON.parse(JSON.stringify(form)).business_natur'
									:params='{"type":"industrys"}'
									:style='"width: 100%;"'>
								</Situationall> -->
								<!-- <a-input v-model="form.business_natur" class='wart-t' :disabled='ipoAduitAdmin'/> -->
								<a-select v-model="form.business_natur" allowClear @select="industryCNChanged">
									<a-select-option v-for="item in industryArr" :key="item.id" :value="item.industry_en">
										{{item.industry_en}}
									</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Market" prop='market'>
								<a-select v-model="form.market" class='warp_width' :disabled='ipoAduitAdmin'>
									<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
										:value="item.value">{{item.entext}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Listing Status" prop='listing_status'>
								<a-select v-model="form.listing_status" class='warp_width' :disabled='ipoAduitAdmin'
									@change='handselefn(form.listing_status,"ruleForm")'>
									<a-select-option v-for="(item) in admintypeArr" :key="item.key + 'b'"
										:value="item.value">{{item.entext}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'  v-if='false'>
							<a-form-model-item label="Submission Date" prop='delivery_date'>
								<a-date-picker v-model="form.delivery_date" @change="handback('delivery_date')"
								:disabled='ipoAduitAdmin'
									:disabled-date="deliveryDate" class='warp_width' placeholder="" />
							</a-form-model-item>
						</a-col>
						<a-col :span='24' class='myright on-center11'>
							<div id='on-center1'>
								<a-form-model-item label="Company Profile" prop='company_profile'>
									<a-textarea v-model="form.company_profile" :auto-size="{ minRows: 4, maxRows: 5 }"
									:maxLength='200' :disabled-date="deliveryDate" class='wart-t'
									:disabled='ipoAduitAdmin'
									@input="form.company_profile=form.company_profile.replace(/[^a-z A-Z]/g,'')" 
										/>
								</a-form-model-item>
							</div>
						</a-col>
					</a-row>
				</a-form-model>
			</div>
		</div>
		<div class='warp_daochu'>
			<div style="padding: .35rem 0;margin-left: auto;">
				<button class='btn1 btnx'  @click='savefn' v-if="!ipoAduitAdmin">保存</button>
				<button class='btn1 ' style="background-color: #f48d28;" @click='gofn'>下一頁</button>
			</div>
		</div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';

	export default {
		props: ['record', 'forms'],
		data() {
			return {
				industryArr:[],
				shKhadmin1Bol: false,
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				rules: {
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					company_name: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					business_natur: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					market: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					listing_status: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					linkaddress: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				england: 'cn',
				admintypeArr:[{
					text: '處理中',
						entext:'Processing',
						value: '0'
					},
					{
						text: '認購中',
						entext:'Subscribing',
						value: '1'
					},
					{
						text: '待上市',
						entext:'Planned IPO',
						value: '2'
					},
					{
						text: '已上市',
						entext:'Listed IPO',
						value: '3'
					},
					{
						text: '已除牌',
						entext:'Delisted',
						value: '4'
					},
					{
						text: '已失效',
						entext:'Expired',
						value: '5'
					}	
				],
				admintypeArrs: [{
						text: '主板',
						entext: 'Mainboard',
						value: '0'
					},
					{
						text: '創業板',
						entext: 'GEM board',
						value: '1'
					},
				],
				remark: '',
				form: {
					company_name: '',
					business_natur: '', 
					market: "",
					listing_status: "", 
					company_profile:'',
					usstockid:1,
					// "pricelist": [{
					// 	"pricekey": "",
					// 	"priceval": ""
					// }, ],
					// stockname_en: '', //股票名稱英文
					// "stockcode": "", //輸入股票代碼
					// "stockname": "", //輸入股票名稱
					// "offer_price_l": '', //招股價起始值
					// "offer_price_h": '', //招股價最大值
					// "pergshu": '', //每手股數
					// "application_open": "", //認購日期起始
					// "application_close": "", //認購日期截止
					// "listingdate": "", //上市日期
					// "entryfee": '', //入場費
					// "cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					
					// "delivery_date": "", //遞表日期
					// "baojianr": "", //保薦機構
					// "anpantime": "", //暗盤時間
					// "multiple": '', //認購倍數
					// info: '',
					// linkaddress: '',
					// pricefileid: '',
					// loan_ratio: '', // 比率
					// loan_days: '', // 日數
					// gain: '', // 利息
					// // "adminid": "", // 錄入人唯一標識
				},
			}
		},
		beforeMount(){
			this.$ajax({
				method: 'post',
				url: this.$api.getParamList,
				data: {"type":"industrys"}
			}).then(res => {
				if (res.data.qmiscode === 1000) {
					this.industryArr = res.data.result;
				} else {
					App.oTool.warningT(res.data.qmismsg);
				}
			})
		},
		mounted() {
			// this.form = JSON.parse(JSON.stringify(this.forms))
		},
		watch: {
			forms: {
				immediate: true,
				deep: true,
				handler(ev) {
					this.form = JSON.parse(JSON.stringify(this.forms))

				}
			}
		},
		mounted() {
		},
		methods: {
			industryCNChanged(obj){
				var item = this.industryArr.find((p)=>{
					if(p.industry == obj){
						return p;
					}
				}
				)
				this.form.business_natur = item.industry_en;
			},
			gofn() {
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						this.$emit("child","handhome2")
					}
				})
			},
			handokfn(){
				this.$refs.ruleForm.validate(valid => {
				if (valid) {
						this.form.token = this.$store.state.token
						this.$ajax({
							method: 'post',
							url: this.$api.newIpoSelling,
							headers: {
								token: this.$store.state.token,
							},
							data: this.form
						}).then(res => {
							console.log(res.data)
							if (res.data.qmiscode == 1000) {
								App.oTool.successT();
								this.$emit('child')
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					}
				})
			},
			savefn() {
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						this.$ajax({
							method: 'post',
							url: this.$api.saveUsMarketStock,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								this.$message.success(res.data.qmismsg)
								// this.$emit('child','save',res.data.id)
							} else {
								this.$message.warning(res.data.qmismsg)
							}
						})
					}
				})
			},
			handselefn(val, ruleForm) {
				this.$emit('childs')
				// if (val == 0) {
				// 	this.rules = this.zerorules
				// } else if (val == 1 || val == 2) {
				// 	this.rules = this.allrules
				// } else if (val == 3) {
				// 	this.rules = this.stockrules
				// }
				// let obj = JSON.parse(JSON.stringify(this.form))
				// this.$refs[ruleForm].resetFields();
				// this.form = obj
			},
			compareDate(dateTime1, dateTime2) {
				var formatDate1 = new Date(this.form[dateTime1])
				var formatDate2 = new Date(this.form[dateTime2])
				if (formatDate1 > formatDate2) {
					this.form[dateTime1] = '';
				}
			},
			handback(val) {
				this.form[val] = this.form[val] ? App.oDate.secsTime3(this.form[val]._d) : ''
				//（遞表日期）》啟示認購日期 》 終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'application_open') {
					if (this.form.application_close && this.form.application_open) {
						this.compareDate('application_open', 'application_close')
					}
				}
				//遞表日期》上市日期
				if (val == 'delivery_date' || val == 'listingdate') {
					if (this.form.delivery_date && this.form.listingdate) {
						this.compareDate('delivery_date', 'listingdate')
					}
				}
				//（遞表日期）》啟示認購日期
				if (val == 'delivery_date' || val == 'application_open') {
					if (this.form.delivery_date && this.form.application_open) {
						this.compareDate('delivery_date', 'application_open')
					}
				}
				//終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'listingdate') {
					if (this.form.application_close && this.form.listingdate) {
						this.compareDate('application_close', 'listingdate')
					}
				}


				//暗盤日期 獲取上市日期前一天
				if (this.form.listingdate) {
					// this.form.anpantime = this.getNextDate(this.form.listingdate, -1)
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'application_close') {
					if (this.form.anpantime && this.form.application_close) {
						this.compareDate('application_close', 'anpantime')
					}
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'delivery_date') {
					if (this.form.anpantime && this.form.delivery_date) {
						this.compareDate('delivery_date', 'anpantime')
					}
				}
			},
			handen() {
				this.form.company_name = this.form.company_name.replace(/<\/?.+?>/g, "");
				this.form.company_name = this.form.company_name.replace(/[\r\n]/g, "");
				this.form.company_name = this.form.company_name.replace(/ +/g, ' ');
				this.form.company_name = this.form.company_name.trim()
			},
			handcn() {
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/<\/?.+?>/g, "");
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/[\r\n]/g, "");
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/ +/g, ' ');
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.trim()
			},
			//禁止選擇
			deliveryDate(current) {
				return current && current > new Date(this.form.listingdate)
			},
			handkong() {
				this.form.info = this.form.info.replace(/<\/?.+?>/g, "");
				this.form.info = this.form.info.replace(/[\r\n]/g, "");
				this.form.info = this.form.info.replace(/ +/g, ' ');
				this.form.info = this.form.info.trim()
			},
			shTgEvent(record, type) { //1通過  //2拒絕
				if (!this.remark) {
					if (type == 1) {
						this.remark = '審核通過'
					} else if (type == 2 && !this.remark) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}

				this.$ajax({
					method: 'post',
					url: this.$api.ipoAdmin,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"iposelling_id": this.form.iposelling_id,
						token: this.$store.state.token,
						"handle": type,
						remark: this.remark
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child');
						this.shShowBol = false;
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
		}
	}
</script>
<style scoped>
	#handitemedits .tabelMoreFzView .tabelMoreFzViewIn {
		background-color: #fff;
		padding: 0.7rem 0;
		border-radius: 4px;
		overflow: hidden;
	}

	#handitemedits .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
		padding: 0.5rem 0;
		border-bottom: 1px #f3f3f3 solid;
		display: flex;
		align-items: flex-start;
	}

	#handitemedits .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
		border: none;
	}

	#handitemedits .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
		width: 24%;
		color: #000;
		font-size: 0.8rem;
	}

	#handitemedits .center {
		/* height: 1.7rem;
		    line-height: 1.7rem; */
	}

	#handitemedits .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
		font-size: 0.8rem;
		width: calc(70% - 2rem);
		color: #000;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#handitemedits .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
		width: 1.2rem;
		height: 1.2rem;
		margin: auto 0;
		margin-left: auto;
	}
</style>
